import { A } from '@ember/array';
import EmberObject from '@ember/object';
import Group from 'mewe/stores/models/group-model';
import JSONSerializer from 'mewe/utils/store-utils/serializers/json-serializer';
import isUndefined from 'mewe/utils/isUndefined';
import { ActionHandler } from '@ember/-internals/runtime';
import { cond, isObject, identity, stubTrue, flip, conforms, isString } from 'lodash';

const serializer = JSONSerializer.create();

const state = EmberObject.extend({
  groups: A(),
}).create();

const getGroupByPublicId = (params) =>
  returnOrCreate(
    state.get('groups').find((g) => g.publicId === params.publicId),
    { publicId: params.publicId }
  );

const create = ({ publicId: publicId }) =>
  state.get('groups').pushObject(Group.create({ publicId: publicId, isFetching: true }));

const isIdValid = (id) => {
  return isString(id) && !isUndefined(id);
};

const returnOrCreate = cond([
  [isObject, identity],
  [stubTrue, flip(create)],
]);

const getState = cond([
  [conforms({ publicId: isIdValid }), getGroupByPublicId],
  [stubTrue, () => state],
]);

const self = EmberObject.extend(ActionHandler, {
  getState: getState,

  actions: {
    handle: (data, publicId) =>
      serializer.updateInstance(getState({ publicId: publicId }), Object.assign(data, { isFetching: false })),

    update: (data, publicId) => serializer.updateInstance(getState({ publicId: publicId }), data),
  },
});

export default self.create();
